import { useEffect, useRef } from 'react';
import { breakpoints, Heading, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css, cx, resetButtonStyle } from '@eti/styles';
import { X } from '@phosphor-icons/react';
import { constants } from '@eti/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const headerWrapperStyles = css`
  align-items: center;
  background-color: ${vars.colors.surface.primary};
  display: flex;
  justify-content: space-between;
  padding: 8px;

  @media (min-width: ${breakpoints._768}) {
    padding: 16px;
  }
`;
export const getCloseButtonStyles = css`
  display: flex;
  padding: 0.0625rem;
  position: relative;
  z-index: 1;

  &::after {
    border: 0.125rem solid ${vars.colors.focusRing};
    border-radius: 0.1875rem;
    content: '';
    height: calc(100% + 2px);
    left: -0.0625rem;
    opacity: 0;
    position: absolute;
    top: -0.0625rem;
    transition: opacity 0.2s ease-in-out;
    width: calc(100% + 2px);
  }

  &:focus-visible {
    &::after {
      opacity: 1;
    }
  }
`;
const overlayContentStyles = css`
  flex: 0 1 100%;
  overflow: auto;
  padding: 16px 8px;

  & > *:not(:last-child) {
    margin-bottom: 16px;
  }

  @media (min-width: ${breakpoints._768}) {
    padding: 16px;
  }
`;
const overlayCardTitleStyles = css`
  font-size: 1.125rem;
  margin-bottom: 16px;
`;
const overlayFooterStyles = css`
  background-color: ${vars.colors.surface.primary};
`;
export const OverlayHeader = _ref => {
  let {
    className,
    onClose,
    shouldApplyMouseflowMask,
    title,
    dialogCloseButtonAriaLabel,
    shouldFocusDrawerHeader
  } = _ref;
  const {
    t
  } = useTranslation();
  const titleRef = useRef(null);
  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.focus();
    }
  }, []);
  useEffect(() => {
    if (shouldFocusDrawerHeader && titleRef.current) {
      titleRef.current.focus();
    }
  }, [shouldFocusDrawerHeader]);
  const headingSRAnnouncement = shouldFocusDrawerHeader ? `${t('ScreenReader.Result.SavedTrip.Drawer.DeletedNotification.Label')}, ${title}` : title;
  return /*#__PURE__*/_jsxs("header", {
    className: cx(headerWrapperStyles, className),
    children: [/*#__PURE__*/_jsx(Heading, {
      "aria-label": headingSRAnnouncement,
      className: shouldApplyMouseflowMask ? constants.MOUSE_FLOW_CLASS_NAMES : '',
      id: "modal-title",
      level: 2,
      ref: titleRef,
      tabIndex: -1,
      children: title
    }), onClose && /*#__PURE__*/_jsx("button", {
      "aria-label": dialogCloseButtonAriaLabel !== null && dialogCloseButtonAriaLabel !== void 0 ? dialogCloseButtonAriaLabel : t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
      className: cx(resetButtonStyle, getCloseButtonStyles),
      "data-testid": "overlay-close",
      onClick: onClose,
      type: "button",
      children: /*#__PURE__*/_jsx(X, {
        "aria-hidden": true,
        size: 24,
        weight: "light"
      })
    })]
  });
};
export const OverlayContent = _ref2 => {
  let {
    children,
    className,
    innerRef,
    role,
    ...props
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: cx(overlayContentStyles, className),
    ref: innerRef,
    role: role !== null && role !== void 0 ? role : 'main',
    ...props,
    children: children
  });
};
export const OverlayCardTitle = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/_jsx("h3", {
    className: overlayCardTitleStyles,
    children: children
  });
};
export const OverlayFooter = _ref4 => {
  let {
    children,
    className,
    innerRef,
    ...props
  } = _ref4;
  return /*#__PURE__*/_jsx("footer", {
    className: cx(overlayFooterStyles, className),
    ref: innerRef,
    ...props,
    children: children
  });
};
//# sourceMappingURL=OverlayComponents.js.map